import { render, staticRenderFns } from "./FilesDownload.vue?vue&type=template&id=28ad24b0"
import script from "./FilesDownload.vue?vue&type=script&lang=js"
export * from "./FilesDownload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports